var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"flex-column"},[_c(_setup.NavigationHeader,{attrs:{"title":_setup.I18NGetter().PlatformSection.nps}}),_vm._v(" "),_c('v-col',[_c('v-card',{staticClass:"mx-6"},[_c('v-card-text',[_c(_setup.NpsDataTable)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }